export const OPEN = 'ERROR_MODAL/OPEN';
export const CLOSE = 'ERROR_MODAL/CLOSE';

export const errorOpenModal = ({ title, message }) => ({
  type: OPEN,
  title,
  message
});
export const errorCloseModal = () => ({ type: CLOSE });
